import { render } from "./Subscriptions.vue?vue&type=template&id=15b61fea&scoped=true&bindings={\"showEndedSubscriptions\":\"data\",\"subscriptionsAndProductsLoaded\":\"options\",\"subscriptions\":\"options\",\"activeBasicSubscriptions\":\"options\",\"endedSubscriptions\":\"options\",\"activeWorkspace\":\"options\",\"isWorkspaceAdmin\":\"options\",\"toggleEndedSubscriptions\":\"options\"}"
import script from "./Subscriptions.vue?vue&type=script&lang=js"
export * from "./Subscriptions.vue?vue&type=script&lang=js"

import "./Subscriptions.vue?vue&type=style&index=0&id=15b61fea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15b61fea"

export default script